import {
  visit
} from "../../../chunk-NEG2FAMT.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMarkdown/textDirection.ts
var AUTO_DIRECTION_TAGS = /* @__PURE__ */ new Set(["p", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "ul", "ol", "table"]);
function rehypeTextDirection() {
  return (tree) => {
    visit(tree, "element", (node, _index, parent) => {
      const dir = node.tagName === "pre" ? "ltr" : parent?.type === "root" && AUTO_DIRECTION_TAGS.has(node.tagName ?? "") ? "auto" : void 0;
      if (dir) node.properties = { ...node.properties, dir };
    });
  };
}
export {
  rehypeTextDirection
};
//# sourceMappingURL=textDirection.mjs.map